interface BrandIconProps {
  size?: number;
  className?: string;
}

export const BrandIcon = ({ size = 80, className = '' }: BrandIconProps) => (
  <div
    className={`flex shrink-0 items-center justify-center ${className}`}
    style={{
      width: size,
      height: size,
      borderRadius: Math.round(size * 0.25),
      background: 'linear-gradient(180deg, #ffffff 0%, #f9f9f9 100%)',
      boxShadow:
        '0px 12px 16px -4px rgba(18, 25, 38, 0.08), 0px 4px 6px -2px rgba(18, 25, 38, 0.03)',
    }}
  >
    <img
      src="/brand/givebutter-icon.svg"
      alt="Givebutter"
      style={{
        width: Math.round(size * 0.55),
        height: Math.round(size * 0.55),
        filter:
          'drop-shadow(0px 1.5px 4.5px rgba(16, 24, 40, 0.1)) drop-shadow(0px 1.5px 3px rgba(16, 24, 40, 0.06))',
      }}
    />
  </div>
);
